import React from 'react';
import PropTypes from 'prop-types';

function showSideBar() {
  document
    .querySelector('body')
    .classList.add('sidebar-filter-active');
}

function hideSideBar() {
  if (
    document
      .querySelector('body')
      .classList.contains('sidebar-filter-active')
  )
    document
      .querySelector('body')
      .classList.remove('sidebar-filter-active');
}

const Drawer = ({ show, onHide, children }) => {
  React.useEffect(() => {
    if (show) showSideBar();
    else hideSideBar();
  }, [show]);

  return (
    <React.Fragment>
      <div className="sidebar-filter-overlay" onClick={onHide} />
      <aside className="sidebar-shop sidebar-filter">
        <div className="sidebar-filter-wrapper">{children}</div>
      </aside>
    </React.Fragment>
  );
};

Drawer.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Drawer;
